var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#52576A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84843 7.26491C8.19219 7.24342 8.48828 7.50468 8.50976 7.84843L9.28931 20.3213C9.28946 20.3236 9.28959 20.3259 9.28971 20.3282C9.31127 20.7479 9.58993 20.9838 9.91417 20.9838H17.086C17.4071 20.9838 17.6845 20.7531 17.7108 20.3221L18.4905 7.84843C18.5119 7.50468 18.808 7.24342 19.1518 7.26491C19.4955 7.28639 19.7568 7.58248 19.7353 7.92624L18.9558 20.3982C18.9558 20.3982 18.9558 20.3983 18.9558 20.3983C18.894 21.4086 18.1424 22.2311 17.086 22.2311H9.91417C8.86768 22.2311 8.09844 21.4158 8.04426 20.3959L7.26491 7.92624C7.24342 7.58248 7.50468 7.28639 7.84843 7.26491Z",
    fill: "#D1D7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01636 7.88731C6.01636 7.54289 6.29557 7.26367 6.64 7.26367H20.3601C20.7045 7.26367 20.9837 7.54289 20.9837 7.88731C20.9837 8.23174 20.7045 8.51095 20.3601 8.51095H6.64C6.29557 8.51095 6.01636 8.23174 6.01636 7.88731Z",
    fill: "#D1D7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9391 6.01633C11.8984 6.01621 11.858 6.02414 11.8203 6.03968C11.7827 6.05522 11.7485 6.07805 11.7196 6.10686C11.6908 6.13567 11.668 6.16989 11.6525 6.20755C11.6369 6.24522 11.629 6.28558 11.6291 6.32632L11.6291 6.32815V7.88725C11.6291 8.23168 11.3499 8.51089 11.0055 8.51089C10.6611 8.51089 10.3818 8.23168 10.3818 7.88725V6.32895C10.3814 6.12414 10.4213 5.92126 10.4994 5.73193C10.5777 5.54227 10.6926 5.36996 10.8377 5.22489C10.9828 5.07983 11.1551 4.96488 11.3447 4.88664C11.5341 4.80854 11.7369 4.76858 11.9417 4.76905H15.0584C15.2632 4.76858 15.466 4.80854 15.6554 4.88664C15.845 4.96487 16.0173 5.07983 16.1624 5.22489C16.3075 5.36996 16.4224 5.54228 16.5007 5.73193C16.5788 5.9213 16.6187 6.12423 16.6183 6.32908V7.88725C16.6183 8.23168 16.339 8.51089 15.9946 8.51089C15.6502 8.51089 15.371 8.23168 15.371 7.88725V6.32815L15.371 6.32632C15.3711 6.28558 15.3632 6.24522 15.3476 6.20755C15.3321 6.16989 15.3093 6.13566 15.2804 6.10686C15.2516 6.07805 15.2174 6.05522 15.1797 6.03968C15.1421 6.02414 15.1017 6.01621 15.061 6.01633L15.0591 6.01633H11.9409L11.9391 6.01633Z",
    fill: "#D1D7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 9.7583C13.8445 9.7583 14.1237 10.0375 14.1237 10.3819V19.1129C14.1237 19.4573 13.8445 19.7366 13.5001 19.7366C13.1557 19.7366 12.8765 19.4573 12.8765 19.1129V10.3819C12.8765 10.0375 13.1557 9.7583 13.5001 9.7583Z",
    fill: "#D1D7E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6715 9.75871C11.0157 9.74641 11.3047 10.0155 11.317 10.3597L11.6288 19.0907C11.6411 19.4349 11.372 19.7239 11.0278 19.7362C10.6836 19.7485 10.3946 19.4794 10.3823 19.1352L10.0705 10.4042C10.0582 10.06 10.3273 9.771 10.6715 9.75871Z",
    fill: "#D1D7E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3286 9.75871C16.6728 9.771 16.9419 10.06 16.9296 10.4042L16.6177 19.1352C16.6054 19.4794 16.3164 19.7485 15.9722 19.7362C15.628 19.7239 15.359 19.4349 15.3713 19.0907L15.6831 10.3597C15.6954 10.0155 15.9844 9.74641 16.3286 9.75871Z",
    fill: "#D1D7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.b2ccf749820611c1e4335f18b60787a3.svg";
export { ForwardRef as ReactComponent };